import type { RadioOption } from '@/app/components/shared/CustomRadioGroup';
import type { I18nRecord, Lane } from '@/app/types';
import { createI18nConfig } from '@/app/utils';

export const MAX_VIDEO_COVER_SIZE = 1 * 1024 * 1024; // 1MB
export const MAX_VIDEO_FILE_SIZE = 2 * 1024 * 1024 * 1024; // 2GB
export const MAX_VIDEO_DURATION = 30 * 60; // 30 minutes

export const PAGE_SIZE = 20;

export enum POSTS_TYPE {
  INSPIRATION = 'inspiration',
  SHORT_FILM = 'shortFilm',
  TUTORIAL = 'tutorial',
  REFERENCE = 'reference',
}

export const ASPECT_TOLERANCE = 0.01;

export const COLUMN_COUNT = 3;
export const ROW_HEIGHT = 140;
export const GAP = 4;

export const SECT_WAR_ACTIVITY_OPTIONS: (Omit<RadioOption, 'value'> & { value: Lane })[] = [
  {
    label: '上路',
    value: 'top',
  },
  {
    label: '中路',
    value: 'middle',
  },
  {
    label: '下路',
    value: 'bottom',
  },
];

export const POSTS_TOUR_CONFIG: Record<POSTS_TYPE, I18nRecord<{ url: string; width: number }>> = {
  [POSTS_TYPE.INSPIRATION]: createI18nConfig(
    {
      en: { url: 'https://image01.cf.vidu.studio/vidu/media-asset/inspiration_tour_en-2226953d.webp', width: 1200 },
    },
    { url: 'https://image01-aliyun.vidu.zone/vidu/media-asset/inspiration_tour_zh-c4e163d7.webp', width: 1210 },
  ),
  [POSTS_TYPE.SHORT_FILM]: createI18nConfig(
    {
      en: { url: 'https://image01.cf.vidu.studio/vidu/media-asset/short_film_tour_en-a7e42773.webp', width: 1021 },
    },
    { url: 'https://image01-aliyun.vidu.zone/vidu/media-asset/short_film_tour_zh-05117952.webp', width: 1022 },
  ),
  [POSTS_TYPE.TUTORIAL]: createI18nConfig(
    {
      en: { url: 'https://image01.cf.vidu.studio/vidu/media-asset/tutorial_tour_en-1a9e23f6.webp', width: 1030 },
    },
    { url: 'https://image01-aliyun.vidu.zone/vidu/media-asset/tutorial_tour_zh-87371fc6.webp', width: 1022 },
  ),
  [POSTS_TYPE.REFERENCE]: createI18nConfig(
    {
      en: { url: 'https://image01.cf.vidu.studio/vidu/media-asset/refhub_tour_en-4c0db9e9.webp', width: 1055 },
    },
    { url: 'https://image01-aliyun.vidu.zone/vidu/media-asset/refhub_tour_zh-51205e6c.webp', width: 1055 },
  ),
};
